const normalizeId = (value) => String(value || "").trim();

export const getNativeTransactionId = (transaction = {}) =>
  normalizeId(
    transaction?.transactionId ||
    transaction?.transaction_id ||
    transaction?.id
  );

export const createNativeStoreDeliveryCoordinator = () => {
  const deliveriesByTransaction = new Map();

  return {
    stage(delivery) {
      const transactionId = normalizeId(delivery?.store_transaction_id);
      if (!transactionId || !delivery) return false;
      deliveriesByTransaction.set(transactionId, delivery);
      return true;
    },

    takeForFinishedTransaction(transaction) {
      const transactionId = getNativeTransactionId(transaction);
      if (!transactionId) return null;
      const delivery = deliveriesByTransaction.get(transactionId) || null;
      if (delivery) deliveriesByTransaction.delete(transactionId);
      return delivery;
    },
  };
};
